// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__rgkYi","goBack":"styles_goBack__ZcU+E","inActive":"styles_inActive__BM9Kw","continueButton":"styles_continueButton__468vW"};